import React, { useEffect, useState } from "react";
import LandingFooter from "../components/layout/Footer";
import LandingHeader from "../components/layout/Header";
import { Button, Card, Col, Layout, List, Rate, Row, Spin } from "antd";
import { MessageOutlined, PercentageOutlined, PhoneFilled } from "@ant-design/icons";
import Get from "../services/Get";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import VirtualList from 'rc-virtual-list';

const ListService = () => {
  const [data, setData] = useState([]); // Store all loaded data
  const [url, setUrl] = useState();
  const [loading, setLoading] = useState(false); // Loader state
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true); // Tracks if more data can be loaded
  const [searchParams] = useSearchParams();

  const slug = searchParams.get("category");
  const search = searchParams.get("search");

  const navigate = useNavigate();
  const location = useLocation();


  // Fetch data function
  const getData = (pageNumber) => {
    // Prevent duplicate calls
    if (loading) return;

    setLoading(true);

    if (search) {
      Get.SearchListing(search, pageNumber)
        .then((res) => {
          console.log("API Response: ", res.data);

          const newData = res.data.data;

          // Append only unique items to the data array
          setData((prevData) => {
            const uniqueData = [...prevData];
            newData.forEach((item) => {
              if (!prevData.find((prevItem) => prevItem.id === item.id)) {
                uniqueData.push(item);
              }
            });
            return uniqueData;
          });

          setUrl(res.url); // Set image base URL
          setHasMore(newData.length > 0); // Stop fetching if no new data
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      Get.Listing(slug, pageNumber)
        .then((res) => {
          console.log("API Response: ", res.data);

          const newData = res.data.data;

          // Append only unique items to the data array
          setData((prevData) => {
            const uniqueData = [...prevData];
            newData.forEach((item) => {
              if (!prevData.find((prevItem) => prevItem.id === item.id)) {
                uniqueData.push(item);
              }
            });
            return uniqueData;
          });

          setUrl(res.url); // Set image base URL
          setHasMore(newData.length > 0); // Stop fetching if no new data
        })
        .catch((err) => {
          console.error("Error fetching data:", err);
        })
        .finally(() => {
          setLoading(false);
        });
    }

  };

  // Handle scroll
  const onScroll = (e) => {
    const { scrollHeight, scrollTop, clientHeight } = e.currentTarget;

    // Check if the user has scrolled to the bottom
    if (scrollHeight - scrollTop === clientHeight && hasMore && !loading) {
      const nextPage = page + 1; // Increment the page number
      setPage(nextPage); // Update state
      getData(nextPage); // Fetch the next set of items
    }
  };

  // const onCallClicked = (mobile) => {
  //   window.location.href = `tel:${mobile}`;
  // }

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <Layout>
        <LandingHeader />
        <div style={{ padding: "20px", minHeight: '80vh' }}>
          {loading && data.length === 0 ? ( // Show loader if loading is true and no data
            <Spin size="large" style={{ display: "block", margin: "20px auto" }} />
          ) : data.length === 0 && !loading ? ( // Show "No Data Found" if no data and not loading
            <div
              style={{
                textAlign: "center",
                margin: "20px 0",
                fontSize: "18px",
                color: "#666",
              }}
            >
              No Data Found
            </div>
          ) : (
            <Row justify={"center"}>
              <Col xs={24} lg={18} xl={12}>
                <List>
                  <VirtualList
                    data={data}
                    itemHeight={47}
                    itemKey="id"
                    onScroll={onScroll}
                  >
                    {(item) => (
                      <Card
                        className="mb-4 p-4 shadow-md rounded-lg"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "16px",
                        }}
                      >
                        <List.Item
                          key={item.id}
                          style={{
                            display: "flex",
                            flexWrap: "wrap", // Wrap content on smaller screens
                            gap: "20px",
                            alignItems: "center",
                          }}
                        >
                          {/* Business Logo */}
                          <img
                            alt={item.business_name}
                            src={`${url}/${item.logo}`} // Dynamic image URL
                            style={{
                              width: "120px", // Default image size
                              height: "120px",
                              objectFit: "cover",
                              borderRadius: "10px",
                              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                            }}
                          />

                          {/* Business Details */}
                          <div
                            style={{
                              flex: 1,
                              minWidth: "250px", // Ensures text doesn't get squished
                            }}
                          >
                            <List.Item.Meta
                              title={
                                <a
                                  href={item.href}
                                  style={{
                                    fontSize: "18px",
                                    fontWeight: "600",
                                    color: "#333",
                                    textDecoration: "none",
                                  }}
                                >
                                  {item.business_name}
                                </a>
                              }
                              description={
                                <>
                                  {/* Sub-category */}
                                  <p
                                    style={{
                                      margin: 0,
                                      fontSize: "14px",
                                      color: "#666",
                                    }}
                                  >
                                    {item.sub_category?.name}
                                  </p>

                                  {/* Discount */}
                                  {item.discount && (
                                    <p
                                      style={{
                                        margin: "5px 0",
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                      }}
                                    >
                                      <PercentageOutlined /> {item.discount}
                                    </p>
                                  )}

                                  {/* City */}
                                  <p
                                    style={{
                                      margin: "5px 0",
                                      fontSize: "14px",
                                      fontWeight: "500",
                                    }}
                                  >
                                    📍 {item.city}
                                  </p>

                                  {/* Rating */}
                                  <div
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      gap: "8px",
                                    }}
                                  >
                                    <Rate
                                      allowHalf
                                      disabled
                                      defaultValue={parseFloat(item.avg) || 0} // Average rating
                                      style={{ fontSize: "16px" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: "14px",
                                        color: "#666",
                                      }}
                                    >
                                      ({item.avg || "No Ratings"})
                                    </span>
                                  </div>
                                </>
                              }
                            />
                          </div>

                          {/* Action Buttons */}
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              gap: "10px",
                              justifyContent: "center",
                              flexWrap: "wrap", // Wrap buttons on smaller screens
                              minWidth: "150px",
                            }}
                          >
                            <Button
                              type="primary"
                              icon={<MessageOutlined />}
                              onClick={() => navigate(`/business-details/${item.slug}`)}
                              className="form-btn"
                              style={{
                                fontSize: "14px",
                                width: "100%", // Full width for small screens
                              }}
                            >
                              View Details
                            </Button>
                          </div>
                        </List.Item>
                      </Card>
                    )}
                  </VirtualList>
                </List>
              </Col>
            </Row>
          )}
          {loading && data.length > 0 && (
            <Spin style={{ margin: "10px auto", display: "block" }} /> // Loader while loading more
          )}
        </div>
      </Layout>
      <LandingFooter />
    </div >
  );
};

export default ListService;